import { CommonModule } from '@angular/common';
  import { Component, OnInit, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TenderingService } from '@/app/services/tendering-services/tendering.service';
import { DateFormatService } from '@/app/services/date-format.service';
import { MatDialogModule } from '@angular/material/dialog';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from '@/app/environments/environment';
import { HttpClient } from '@angular/common/http';
import { take } from 'rxjs/operators';
import { GetFileIconUtilityService } from '@/app/services/utility/get-file-icon-utility.service';

@Component({
  selector: 'app-rfp-applicant-clarification-queries',
  standalone: true,
  imports: [
    MatIconModule,
    CommonModule,
    MatButtonModule,
    MatDialogModule,
  ],
  templateUrl: './rfp-applicant-clarification-queries.component.html',
  styleUrl: './rfp-applicant-clarification-queries.component.css'
})
export class RfpApplicantClarificationQueriesComponent implements OnInit {
  @Input() projectId: number;
  @Input() rfpId: number;

  queries: any = []
  isQueryExpanded = false;
  groupedQueries: any[] = [];

  docUrl: string | null = null;

  selectedQueryIndex: number | null = null;

  constructor(
    private tenderingService: TenderingService,
    private dateService: DateFormatService,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
   private getFileIconService: GetFileIconUtilityService,
  ) {
  }

  ngOnInit() {
    this.getRfpApplicantQueries()
  }
  getFileIcon(file: {
    file: any;
    preview: string;
    id?: number;
    name?: string;
  }): string {
    return this.getFileIconService.getFileIcon(file);
  }
  toggleSelectedQueryDetails(index: number) {
    this.selectedQueryIndex = this.selectedQueryIndex === index ? null : index;
  }

  // NOTE: this is triggered from parent when applicant create question
  updateQueries() {
    this.queries = [];
    this.getRfpApplicantQueries();
  }

  formatQueryNumber(index: number): string {
    const queryNumber = index + 1;
    return `${queryNumber.toString().padStart(2, '0')}`;
  }

  /**
   * HTTP REQUESTS START
   */
  populatedRfpQueries(rawQuestions: any[], responses: any[]) {
    rawQuestions = rawQuestions || [];
    responses = responses || [];

    const responseMap = new Map(
      responses.map(response => [response.id, response])
    );

    const groupedQueries = new Map();

    rawQuestions.forEach(rawQuestion => {
      // get response for the question if its available
      const matchingResponse = responseMap.get(rawQuestion.query_response_id);
      const answerId = matchingResponse?.id ?? null;

      // Group queries with the same answer_id
      if (!groupedQueries.has(answerId)) {
        groupedQueries.set(answerId, {
          queries: [],
          answer: matchingResponse?.answer || null,
          attachedFiles: matchingResponse?.attached_files? JSON.parse(matchingResponse.attached_files) : null,
          newFiles: matchingResponse?.clarification_new_files || null
        });
      }

      groupedQueries.get(answerId).queries.push({
        id: rawQuestion?.id,
        query: rawQuestion?.question,
        date: this.dateService.formatDate(rawQuestion?.created_at),
        avatar: 'https://storage.googleapis.com/a1aa/image/zEPAjIvYaPYMOh7zu6qdyFAjf7Qz2R3B3nMXb2N9N8WucBAKA.jpg'
      });
    });

    this.groupedQueries = groupedQueries ? Array.from(groupedQueries.values()) : [];
  }

  getRfpApplicantQueries() {
    this.tenderingService.getRfpApplicantQueries(this.projectId, this.rfpId).subscribe({
      next: (response: any) => {
        if (response.meta.success) {
          this.getRfpApplicantQueriesResponses(response.data);
        }
      },
      error: (error) => {
        console.error('Error fetching data:', error);
      },
    });
  }

  getRfpApplicantQueriesResponses(rawQuestions: any[]) {
    this.tenderingService.getRfpApplicantQueriesResponses(this.projectId, this.rfpId).subscribe({
      next: (response: any) => {
        if (response.meta.success) {
          console.log(response.data);
          this.populatedRfpQueries(rawQuestions, response.data);
        }
      },
      error: (error) => {
        console.error('Error fetching data:', error);
      },
    });
  }

  downloadRfpResponseDocument(
    event: Event,
    downloadLink: HTMLAnchorElement,
    file: any
  ): void {
    event.preventDefault();
    console.log('file:', file);

    const id = file.id;
    const filePath = file.file_path;
    console.log('filePath:', filePath);
    console.log('id:', id);

    const parts = filePath.split('/');
    const _filePath = parts[parts.length - 1];

    const apiUrl = environment.apiUrl;
    const fullPath = `${apiUrl}/projects/${this.projectId}/tendering/rfp/${this.rfpId}/clarifications/download/documents/${id}/${_filePath}`;

    const href = downloadLink.getAttribute('href'); // Get the href attribute
    console.log('href:', href);
    console.log('fullPath', fullPath)
    if (href !== '#') {
      console.log('The download is already in progress');
      return;
    }

    // Open a new blank tab immediately (before async request)
    const newTab = window.open('', '_blank');

    // Fetch the image from the backend
    this.http.post(fullPath, {}, { responseType: 'blob' })
  .pipe(take(1))
  .subscribe({
    next: (blob: Blob) => {
      if (!(blob instanceof Blob)) {
        console.error('Received invalid blob response');
        newTab?.close(); // Close the tab if request fails
        return;
      }

      const docUrl = URL.createObjectURL(blob);
      newTab!.location.href = docUrl; // Assign the Blob URL to the new tab

      // Cleanup memory
      setTimeout(() => URL.revokeObjectURL(docUrl), 5000);
    },
    error: (error) => {
      console.error('Error opening document:', error);
      newTab?.close(); // Close the tab if request fails
    }
  });

  }

  downloadRfpResponseDocumentV1(
    event: Event,
    id: number,
    filePath: string
  ): void {
    event.preventDefault();

    const parts = filePath.split('/');
    const _filePath = parts[parts.length - 1];

    const apiUrl = environment.apiUrl;
    const fullPath = `${apiUrl}/projects/${this.projectId}/tendering/rfp/${this.rfpId}/clarifications/download/documents/${id}/${_filePath}`;

    // Fetch the image from the backend
    this.http.post(fullPath, {}, { responseType: 'blob' }).subscribe((blob) => {
      const docUrl = window.URL.createObjectURL(blob); // Create a blob URL

      // Create a temporary anchor element to trigger the download
      const tempLink = document.createElement('a');
      tempLink.href = docUrl;
      tempLink.download = _filePath; // Set the file name
      tempLink.click(); // Trigger the download

      // Clean up the blob URL after use
      window.URL.revokeObjectURL(docUrl);
    });
  }
  /**
   * HTTP REQUESTS END
   */

  getSanitizedHtml(description: string) {
    if (!description) {
      return '';
    }
    return this.sanitizer.bypassSecurityTrustHtml(description);
  }

}
